import { Checkbox } from '@mui/material'
import useStyle from './useStyle'

function TableHeader () {
  const classes = useStyle()
  return (
    <thead className={classes.row}>
      <tr>
        <th className={classes.headCheck}>
          <Checkbox />
        </th>
        <th className={classes.headStatus}>Estado de acceso</th>
        <th className={classes.headName}>Nombre del Estudio</th>
        <th className={classes.headCuit}>CUIT</th>

        <th className={classes.headDate}>Fecha Desde/Hasta</th>
        {/* <th className={classes.numbersOfActiveUser}>Colaboradores Activos</th>
        <th className={classes.numbersOfDerivedUser}>Usuarios Derivados</th> */}
        <th className={classes.numbersOfModules}>Módulos habilitados</th>
        <th className={classes.headKebab}></th>
      </tr>
    </thead>
  )
}

export default TableHeader
